(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.gestaoOcorrencias', {
      url: '/tempo-real/gestao-ocorrencias',
      views: {
        'content@': {
          templateUrl: 'gestao-ocorrencia/gestao-ocorrencia.tpl.html',
          controller: 'GestaoOcorrenciasCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.gestaoOcorrencia.titulo',
        role: ['OCORRENCIA_VISUALIZAR']
      }
    });
  }

  angular
    .module('gestaoOcorrencia')
    .config(pageConfig);
}());
